"use strict";

(function (globalFooter) {

  var FLOAT_DIALOG_TEMPLATE = '/layouts/FloatDialog.compile.html';
  var AGENT_NOT_STARTED_OR_NOT_INSTALLED_TEMPLATE = '/components/agentNotStartedOrNotInstalled.html';  // Скомпилированные шаблоны не позволяют использовать функцию L
  var TITLE_TEMPLATE = '{title}<span class="opened-documents-widget__counter">({count})</span>';
  var CONTENT_TEMPLATE = '<div class="opened-documents-widget__content">{content}</div>';

  var OpenedDocumentsWidget = WA.components.dialogs.FloatDialog.extend({

    // Конструктор.
    init: function (args) {
      var me = this;

      me._super('openedDocumentsWidget', {
        title: L('OPENED_DOCUMENTS_TITLE'),
        showMinimizeButton: true,
        minimized: true,
        showCloseButton: false,
        isLoading: true,
        hidden: true,
        loadingText: L('OPENED_DOCUMENTS_LOADING_TEXT')
      });

      me.setMinimized(true);
      me._requestGetOpenedDocuments();
      me._startGetOpenedDocumentsTimer(5); //5 сек.
    },

    // Запускает таймер получения редактируемых документов.
    _startGetOpenedDocumentsTimer: function (intervalInSec) {
      var me = this;
      setTimeout(function () {
        me._requestGetOpenedDocuments();
        me._startGetOpenedDocumentsTimer(intervalInSec);
      }, intervalInSec * 1000);
    },

    // Отправляет запрос к агенту для получения списка редактируемых документов, а потом обрабатывает его.
    _requestGetOpenedDocuments: function () {
      var me = this;

      WA.agent.edms.getOpenedDocuments().done(function (docs) {
        // Агент ответил, проверим изменились ли данные.
        if ($.toJSON(docs) != $.toJSON(me._prevDocs)) {
          var count = docs.length;
          if (count) {
            // Если есть неотслеживаемые документы, то раскрыть список. Иначе - свернуть. 
            if (!me.isUserExpanded() || me.isMinimized()) {
              me.setMinimized(!_.some(docs, function(doc) { return !doc.IsObservable; }));
            }

            me.getOpenedDocumentsListComponentHtml(docs).done(function (content, js) {
              var titleHtml = format(TITLE_TEMPLATE, { title: L('OPENED_DOCUMENTS_TITLE'), count: count });
              me.setTitleAsHtml(titleHtml);

              var wrappedContent = format(CONTENT_TEMPLATE, { content: content });
              me.setContentAsHtml(wrappedContent, function () {
                if (js) {
                  var f = new Function(js);
                  setTimeout(function() {
                    f.apply(window);

                    // Делаем недоступным контекстное меню для элементов виджета
                    var jOpenDocumentList = me._jContent.find('#OpenedDocumentList');
                    var tr = jOpenDocumentList.children('div.folder_item');
                    tr.unbind('contextmenu.entitylist');
                    // Отключаем обработку клика по иконке
                    tr.find(".object-list-item__icon").off('click.entitylist');
                  }, 10);
                }
              });
              me._prevDocs = docs;
            }).fail(function(message) {
              me.setContent(L('WARN_CANNOT_RETRIEVE_OPENED_DOCUMENTS'));
              me._prevDocs = null;
            }).always(function() {
              me.show();
            });
          } else {
            me.hide();
          }
        }
      }).fail(function () {
        me.hide();
        me.setContent("");
        me._prevDocs = null;
      });
    },

    /**
     * Получить компоненту списка документов.
     *
     * @method getOpenedDocumentsListComponentHtml
     * @param {Array<Object>} docs Документы.
     * @return {Deferred<Object>} Объект с разметкой компоненты и инициализационными скриптами.
     * @see https://api.jquery.com/category/deferred-object/
     */
    getOpenedDocumentsListComponentHtml: function (docs) {
      var def = $.Deferred();

      if (docs.length > 0) {
        CallService("/ModalWindow.asmx/Create", {
          ControlName: "OPENEDDOCUMENTSLIST",
          Params: $.toJSON({
            "Documents": $.toJSON(docs)
          })
        }, function(res) {
          if (res.Success && res.Result.html) {
            def.resolve(res.Result.html, res.Result.initJs);
          } else {
            def.resolve(L("NO_OPENED_DOCUMENTS"), null);
          }
        }, function(message) {
          def.reject(message);
        });
      } else {
        def.resolve(L("NO_OPENED_DOCUMENTS"), null);
      }

      return def;
    }
  });



  // ---------------------------------------------------------------------------------------------------
  //                                          Public functions
  // ---------------------------------------------------------------------------------------------------
  globalFooter.openedDocumentsWidget = (function () {
    var openedDocumentsWidget = null;

    return {
      /**
      * Инициализировать виджет открытых документов. 
      * 
      * @method Core.footer.openedDocumentsWidget.init
      */
      init: function () {
        openedDocumentsWidget = new OpenedDocumentsWidget();
      },

      /**
      * Обновить виджет открытых документов. 
      * 
      * @method Core.footer.openedDocumentsWidget.update
      */
      update: function () {
        if (openedDocumentsWidget) 
          openedDocumentsWidget._requestGetOpenedDocuments();
      }
    };
  })();

})(window.Core.footer);